import axios from 'axios';
import Cookies from 'universal-cookie';

import { BACKEND_BASE_URL, COOKIES_KEY } from '../constants';

const axiosInstance = axios.create({
  baseURL: BACKEND_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosInstance.interceptors.request.use((config) => {
  const cookies = new Cookies();
  const jwtToken = cookies.get(COOKIES_KEY);

  config.headers!.Authorization = jwtToken ? `Bearer ${jwtToken}` : '';
  return config;
});

export { axiosInstance };
